import "slick-carousel";
import "jquery-zoom";

if ($(".slider-has-color-variants").length > 0) {
  let dataOptionTwo = null;
  let colorVariant = null;

  let variantId = window.location.search
    .substr(1)
    .split("&")
    .filter((item) => item.includes("variant"))[0];

  if (variantId) {
    variantId = variantId.split("=")[1];
  }

  if (variantId) {
    const currentValue = $(`#product-select option[value="${variantId}"]`)
      .data("variant-options")
      .split("-");
    colorVariant = currentValue[0];
    dataOptionTwo = currentValue[1];
  } else {
    $("[data-color-variant]").each((x, i) => {
      let _i = $(i).data("color-variant");
      if ($(".js-selected-options").val().includes(_i)) {
        colorVariant = _i;
        return false;
      }
    });

    if ($("[data-option-two-variant]").length > 0) {
      dataOptionTwo = $("[data-option-two-variant]")
        .first()
        .data("option-two-variant");
    }

    if ($("[data-option-two-variant]").length > 0) {
      colorVariant = $("[data-color-variant]").first().data("color-variant");
    }
  }

  let selectedOption = [];
  $(".form__body .js-select-options").each((i, group) => {
    selectedOption.push($(group).find("input.selected-option").val());
  });

  const optionString = selectedOption.join(":");

  if (!variantId || variantId.length < 1) {
    if (
      $(`.js-main-select option[data-variant-options="${optionString}"]`)
        .length > 0
    ) {
      variantId = $(
        `.js-main-select option[data-variant-options="${optionString}"]`
      ).val();
    } else {
      variantId = $(
        `.js-main-select option[data-variant-options^="${selectedOption[0]}"]`
      ).val();
    }
  }

  productSliders(
    true,
    true,
    colorVariant.split(":")[0] || false,
    false,
    dataOptionTwo,
    variantId
  );
} else if ($(".template-product").length > 0) {
  productSliders();
}

$(document).on(
  "click",
  ".section-breadcrumbs + .section-product .js-slider-product-thumbs .slick-slide",
  function () {
    $(this).addClass("slick-current").siblings().removeClass("slick-current");
  }
);

$(document).on(
  "click",
  "#quickshop .js-slider-product-thumbs .slick-slide",
  function () {
    $(this).addClass("slick-current").siblings().removeClass("slick-current");
  }
);

export default function productSliders(
  hasImagesFilter = false,
  initSliders = true,
  colorName = false,
  isQuickshop = false,
  secondOption = false,
  variantId
) {
  const quickshopSelector =
    $("#quickshop.is-open").length > 0 ? "#quickshop.is-open" : "";

  const currentOption = $(
    `${quickshopSelector} .js-main-select option[value="${variantId}"]`
  ).data("variant-options");

  let $productSliders = $(`${quickshopSelector} .js-product-sliders`);
  let productSlider = `${quickshopSelector} .js-slider-product`;
  let productSliderThumbs = `${quickshopSelector} .js-slider-product-thumbs`;

  if (initSliders) {
    initializeSliders(productSlider, productSliderThumbs, isQuickshop);
  }

  if (hasImagesFilter) {
    const activeColor =
      typeof colorName !== undefined
        ? colorName
        : $(productSlider).data("active-color");

    const activeColorFilter = activeColor ? "filter-" + activeColor : "";

    const activeOptionTwo = $($(".js-select-options")[1])
      .find(".selected-option")
      .val();

    const activeOptionTwoFilter = secondOption
      ? `filter-${secondOption}`
      : activeOptionTwo
      ? `filter-${activeOptionTwo}`
      : null;

    addFilterClasses($productSliders);
    filterImages(
      activeColorFilter === "filter-false" ? null : activeColorFilter,
      activeOptionTwoFilter,
      $productSliders,
      currentOption
    );
  }
}

function addFilterClasses($productSliders) {
  $productSliders.find(".slick-slide").each(function () {
    const $this = $(this);
    const colorVariant = $this.find(".slider__slide").data("color-variant");
    const optionTwoVariant = $this
      .find(".slider__slide")
      .data("option-two-variant");
    $this.addClass(`filter-${colorVariant}`);
    optionTwoVariant && $this.addClass(`filter-${optionTwoVariant}`);
  });
}

function filterImages(
  activeColorHandle,
  activeOptionTwoFilter = null,
  $productSliders,
  currentOption
) {
  const currentOptionSplit = currentOption.split(":");

  let colorSelector = activeColorHandle
    ? `.${activeColorHandle.split(":")[0]}`
    : "";

  colorSelector = colorSelector.split("/").join("-");

  const optionTwoSelector = activeOptionTwoFilter
    ? `.${activeOptionTwoFilter}`
    : "";

  let shouldFilter = false;

  $productSliders.slick("slickUnfilter");
  if (colorSelector.length > 0) {
    shouldFilter = $(colorSelector).length > 0;
  } else if (optionTwoSelector.length > 0) {
    shouldFilter = $(colorSelector).length > 0;
  }

  if (shouldFilter) {
    $productSliders.slick("slickFilter", function () {
      if ($(this).attr("class").split(" ").length > 1) {
        return (
          $(this).attr("class").includes(`filter-${currentOptionSplit[0]}`) &&
          $(this).attr("class").includes(`filter-${currentOptionSplit[1]}`)
        );
      } else {
        return $(this).attr("class") === `filter-${currentOptionSplit[0]}`;
      }
    });

    // if there are no images connected to the color, display all images
    if ($productSliders.find(".slick-slide").length <= 0) {
      $productSliders.slick("slickUnfilter");
    }

    reIndexSlides($productSliders);
  }
}

function initializeSliders(slider1, slider2, isQuickshop) {
  const $slider1 = $(slider1).last();
  const $slider2 = $(slider2).last();

  if (!isQuickshop) {
    $(slider1)
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        asNavFor: slider2,
        fade: true,
        cssEase: "linear",
      })
      .on("afterChange", function () {
        $(".zoom").trigger("zoom.destroy");
        zoomBehaviour();
      });

    $(slider2).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: slider1,
      focusOnSelect: true,
    });
  } else {
    $slider1
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        asNavFor: $slider2,
        fade: true,
        cssEase: "linear",
      })
      .on("afterChange", function () {
        $(".zoom").trigger("zoom.destroy");
        zoomBehaviour();
      });

    $slider2.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: $slider1,
      focusOnSelect: true,
    });
  }
}

export function zoomBehaviour() {
  if (window.innerWidth < 1024) {
    $(".zoom").zoom({ on: "toggle" });
  } else {
    $(".zoom").zoom({ on: "mouseover" });
  }
}

if (!window.location.pathname.includes("/collections/")) {
  zoomBehaviour();
}

if (!window.location.pathname.includes("/collections/")) {
  $(window).on("resize", function () {
    $(".zoom").trigger("zoom.destroy");
    zoomBehaviour();
  });
}

function reIndexSlides($slick) {
  const $slides = $slick.find(".slick-slide:not(.slick-cloned)");
  $slides.each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
  });

  $slick.slick("slickGoTo", 0, true);
}
